import { Route, Routes, useLocation, useNavigationType } from "react-router-dom";
import { AnimatePresence, motion } from "motion/react";
import { useBackButton } from "../telegram/useBackButton";
import { slideVariants } from "../motion";
import Home from "./Home";
import Prices from "./Prices";
import Detail from "./Detail";
import PieceForm from "./PieceForm";

/**
 * Routes are imported, not lazy-loaded: a Suspense fallback on the way into a
 * record would leave the thumbnail with no hero to grow into.
 */
export function AppRoutes() {
  const location = useLocation();
  const navigationType = useNavigationType();
  useBackButton();

  // POP is the back button (Telegram's or the browser's): play the transition
  // in reverse so going back never feels like going somewhere new.
  const direction: 1 | -1 = navigationType === "POP" ? -1 : 1;
  const variants = slideVariants(direction);

  return (
    <AnimatePresence mode="popLayout" initial={false}>
      <motion.div
        key={location.pathname}
        variants={variants}
        initial="hidden"
        animate="show"
        exit="exit"
        style={{ position: "absolute", inset: 0 }}
      >
        <Routes location={location}>
          <Route path="/" element={<Home />} />
          <Route path="/prices" element={<Prices />} />
          <Route path="/piece/:id" element={<Detail />} />
          <Route path="/piece/:id/edit" element={<PieceForm />} />
          <Route path="/new" element={<PieceForm />} />
          <Route path="*" element={<Home />} />
        </Routes>
      </motion.div>
    </AnimatePresence>
  );
}
